/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Usage_Total_Budget_Remaining_AmountInputs */



/**
* | output |
* | --- |
* | "Remaining {amount}" |
*
* @param {Usage_Total_Budget_Remaining_AmountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_total_budget_remaining_amount = /** @type {((inputs: Usage_Total_Budget_Remaining_AmountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Total_Budget_Remaining_AmountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verbleibend ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Remaining ${i?.amount}`)
});